/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface MasterDataPreferredEmailTypesGet$Params {
}

export function masterDataPreferredEmailTypesGet(http: HttpClient, rootUrl: string, params?: MasterDataPreferredEmailTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataPreferredEmailTypesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

masterDataPreferredEmailTypesGet.PATH = '/MasterData/PreferredEmailTypes';
